import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls';// import { Collapse } from 'react-bootstrap';
import { DonaturTrxTable } from './DonaturTrxTable';
import { DonaturTrxUIProvider } from './DonaturTrxUIContext';
import { DonationFilter } from './donation-filter/DonationFilter';
import { Collapse, Badge } from 'react-bootstrap';
import { useDonaturTrxUIContext } from '../donatur-trx/DonaturTrxUIContext';
import { PrintDonaturTrxConsolidationExportDialog } from './consolidation-download/PrintDonaturTrxConsolidationExportDialog'
import { RoleChecker } from '../../../RoleChecker';



const DonaturTrx = ({ user_uuid, donaturType, tab, openDetailDonationPage, merge }) => {

	const [open, setOpen] = useState(false);
	const changeShow = () => {
		setOpen(!open);
	};

	const donaturTrxUIContext = useDonaturTrxUIContext();
	const donaturTrxUIProps = useMemo(() => {
		return {
			openConsolidationDialog: !merge ? donaturTrxUIContext.openConsolidationDialog : null,
			closeConsolidationDialog: !merge ? donaturTrxUIContext.closeConsolidationDialog : null,
			setOpenConsolidationDialog: !merge ? donaturTrxUIContext.setOpenConsolidationDialog : null
		};
	}, [donaturTrxUIContext]);

	console.log(donaturTrxUIProps);
	return (
		<div>
			<Card>
				<CardHeader title=''>
					<CardHeaderToolbar>
						{RoleChecker("Cetak Konsolidasi", "detail_donatur") && <button
							type="button"
							className="btn btn-info mr-2"
							onClick={() => donaturTrxUIProps.setOpenConsolidationDialog(true)}
						>
							Cetak Konsolidasi
						</button>}
						<button
							type="button"
							className="btn btn-warning mr-2"
							onClick={changeShow}
							aria-controls="collapse-filter-donasi"
							aria-expanded={open}
						>Cari
						</button>

					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<DonaturTrxUIProvider donaturUuid={user_uuid}>
						<Collapse in={open}>
							<div id="collapse-filter-donasi">
								<DonationFilter user_uuid={user_uuid} donaturType={donaturType} />
							</div>
						</Collapse>
						{!merge && <PrintDonaturTrxConsolidationExportDialog
							show={donaturTrxUIProps.openConsolidationDialog}
							onHide={donaturTrxUIProps.closeConsolidationDialog}
						/>}
						<DonaturTrxTable donaturType={donaturType} tab={tab} openDetailDonationPage={openDetailDonationPage} />
					</DonaturTrxUIProvider>
				</CardBody>
			</Card>

		</div>
	);
};

export default DonaturTrx;
